import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  loading: false,
  role: "",
};

const userReq = createAction("userByIdRequest");
const userSuccess = createAction("userByIdSuccess");
const userFail = createAction("userByIdFailure");

const creatorSubscribed = createAction("creatorSubscribedRequest");
const creatorSubscribedSuccess = createAction("creatorSubscribedSuccess");
const creatorSubscribedFail = createAction("creatorSubscribedFailure");

const getAllCreatorsRequest = createAction("getAllCreatorsRequest");
const getAllCreatorsSuccess = createAction("getAllCreatorsSuccess");
const getAllCreatorsFail = createAction("getAllCreatorsFailure");

const userRoleSuccess = createAction("userRoleSuccess");

const clear = createAction("clearUserData");

export const authReducer = createReducer(initialState, (builder) => {
  builder
    // User by Id
    .addCase(userReq, (state, action) => {
      state.loading = true;
    })
    .addCase(userSuccess, (state, action) => {
      state.loading = false;
      state.userData = action.payload.user;
    })
    .addCase(userFail, (state, action) => {
      state.loading = false;
    })

    .addCase(userRoleSuccess, (state, action) => {
      state.userRole = action.payload;
    })

    // Creator Subscribed
    .addCase(creatorSubscribed, (state, action) => {
      state.loading = true;
    })
    .addCase(creatorSubscribedSuccess, (state, action) => {
      state.loading = false;
      state.subscribedCreators = action.payload.users;
    })
    .addCase(creatorSubscribedFail, (state, action) => {
      state.loading = false;
    })

    // Get All Creators
    .addCase(getAllCreatorsRequest, (state, action) => {
      state.loading = true;
    })
    .addCase(getAllCreatorsSuccess, (state, action) => {
      state.loading = false;
      state.allCreators = action.payload.creators;
    })
    .addCase(getAllCreatorsFail, (state, action) => {
      state.loading = false;
    })

    // Clear User Data
    .addCase(clear, (state, action) => {
      state.userData = null;
    });
});
